import { NavLink } from "react-router-dom";
import { useUserInfor } from "../../../Context/User";
import { ACESSOS } from "../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../Validations/UsuarioTela";
import SubNavDropDown from "../SubNavDropDown/SubNavDropDown";
import { SubNavGestaoVistoriaEntrega } from "./subnavsVistoria";
import { SubNavGestaoCadastroVistoria } from "./subnavsVistoria/GestaoCadastro";
import { SubNavRelatoriosVistoriaEntregaChaves } from "./subnavsVistoria/RelatoriosVistoriaEntrega";

interface IVistoriaEntregaChaveTabProps {}

export default function VistoriaEntregaChaveTab(
    props: IVistoriaEntregaChaveTabProps
) {
    const { UserInfor } = useUserInfor();

    return (
        <div className="tab-pane py-5 p-lg-0 active" id="CobrancaTab">
            <div
                id="kt_header_menu2"
                className="header-menu header-menu-mobile header-menu-layout-default header-menu-root-arrow"
            >
                <ul className="menu-nav">
                    {/* {mostrarNavDeTela(
                        ACESSOS.ENTREGA_DE_CHAVES.TELAS.DASHBOARD.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.DASHBOARD
                                        .DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text"> Dashboard </span>
                            </NavLink>
                        </li>
                    )} */}
                    {mostrarNavDeTela(
                        ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_CLIENTES.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.ENTREGA_DE_CHAVES.TELAS
                                        .GESTAO_CLIENTES.DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    {" "}
                                    Gestão de Clientes{" "}
                                </span>
                            </NavLink>
                        </li>
                    )}
                    <SubNavDropDown
                        title={"Atendimentos"}
                        telas={[
                            ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTOS
                                .MEUS_ATENDIMENTOS.USUARIO.ID_TELA,
                            ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTOS
                                .MEUS_ATENDIMENTOS.ACOMPANHAMENTO.ID_TELA,
                        ]}
                    >
                        <SubNavGestaoVistoriaEntrega />
                    </SubNavDropDown>
                    <SubNavDropDown
                        title={"Gestão de Cadastros"}
                        telas={[
                            ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_CADASTRO
                                .DISPONIBILIDADE_VISTORIA.ID_TELA,
                            ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_CADASTRO
                                .HORARIOS_DISPONIVEIS.ID_TELA,
                        ]}
                    >
                        <SubNavGestaoCadastroVistoria />
                    </SubNavDropDown>
                    {mostrarNavDeTela(
                        ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_VISTORIA.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.ENTREGA_DE_CHAVES.TELAS
                                        .GESTAO_VISTORIA.DS_PATH
                                }
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    {" "}
                                    Gestão Vistorias e Entrega Chaves{" "}
                                </span>
                            </NavLink>
                        </li>
                    )}
                    <SubNavDropDown
                        title={"Relatórios"}
                        telas={[
                            ACESSOS.ENTREGA_DE_CHAVES.TELAS.CAPYS_BI.ID_TELA,
                            ACESSOS.ENTREGA_DE_CHAVES.TELAS
                                .ACOMPANHAMENTOS_VISTORIA.ID_TELA,
                        ]}
                    >
                        <SubNavRelatoriosVistoriaEntregaChaves />
                    </SubNavDropDown>
                </ul>
            </div>
        </div>
    );
}
